import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'
import { Router } from './router/Router'

const GlobalBottomComponents = () => {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  )
}

function App() {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Router />
        <GlobalBottomComponents />
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
